import React from 'react';
import i18n from 'util/i18n';
import './HelpVideo.scss';

export class HelpVideo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="token-error login eapp-core" id="login">
        <div className="eapp-structure-row">
          <div id="seal-header" className="seal-header">
            <div className="eapp-structure-left eapp-logo" id="logo">
              <img src="/img/dcsa-logo.png" alt="National Background Investigation Services" />
              <h3 className="help-header-lg">{i18n.t('login.token.heading')}</h3>
            </div>
          </div>
        </div>
        <div className="help-content-background" />
        <div className="video-container" id="video-container">
          <video width="640" height="480" controls>
            <source src="/img/IntroductionToeApp.mp4" type="video/mp4" />
            Your browser does not support HTML5 video.
            <p>Your browser doesn't support HTML5 video. You can still watch it
              <a href="/img/IntroductionToeApp.mp4">here</a> instead.
            </p>
          </video>
        </div>
      </div>
    );
  }
}

export default HelpVideo;
